import dynamic from 'next/dynamic'
import React from 'react'

import { Theme, useMediaQuery } from '@mui/material'

import Box from 'app/components/base/Box'
import Stack from 'app/components/base/Stack'
import SearchAppProvider, {
  DISJUNCTIVE_FACETS,
  FACETS,
  RESULT_FIELDS,
  SEARCH_FIELDS
} from 'app/features/SearchFeature/providers/SearchProvider'
import SearchAppResult from 'app/features/SearchFeature/SearchResult'

import CategoryViewContainer from './CategoryViewContainer'
import FilterPanel from './FilterPanel'
import SearchCategoryTitle from './SearchCategoryTitle'

const BoxLicenseInformation = dynamic(
  () => import('~/views/CategoryView/components/BoxLicenseInformation'),
  {
    ssr: false
  }
)

const SearchPagination = dynamic(
  () => import('app/features/SearchFeature/components/SearchPagination'),
  {
    ssr: false
  }
)

const ActiveFilters = dynamic(
  () => import('app/features/HomePageFeature/ChipFeature/ActiveFilters')
)

interface SearchSectionProps {
  searchCategory: string
}

const SearchSection: RFC<SearchSectionProps> = ({ searchCategory }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  return (
    <SearchAppProvider
      searchQuery={{
        facets: FACETS,
        disjunctiveFacets: DISJUNCTIVE_FACETS,
        search_fields: SEARCH_FIELDS,
        result_fields: RESULT_FIELDS
      }}
      key={searchCategory}
      searchCategory={searchCategory}
    >
      <Stack sx={{ overflowX: 'hidden', pb: { xs: 3, md: 10 } }}>
        <Box
          sx={{
            ...(!isMobile && { boxShadow: '0px 12px 24px -4px #919EAB26' }),
            mb: { xs: 2, md: 2.25 }
          }}
        >
          <CategoryViewContainer>
            <FilterPanel />
          </CategoryViewContainer>
        </Box>

        <Stack spacing={2} sx={{ display: { md: 'none' } }}>
          {isMobile && <ActiveFilters />}

          <CategoryViewContainer>
            <BoxLicenseInformation />
          </CategoryViewContainer>
        </Stack>

        <CategoryViewContainer>
          <Stack spacing={{ xs: 3.75, sm: 5 }} sx={{ mt: 1 }}>
            <Stack spacing={3}>
              <SearchCategoryTitle searchCategory={searchCategory} />

              <SearchAppResult />
            </Stack>

            <SearchPagination />
          </Stack>
        </CategoryViewContainer>
      </Stack>
    </SearchAppProvider>
  )
}

export default SearchSection
